import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import policies, { policyMap } from "../policies";
import "../css/policy.scss";

export const PolicyDocument = ({ policy }) => (
  <main className="policy-page" id="main">
    <header className="policy-hero">
      <p>fumvella policies</p>
      <h1>{policy.title}</h1>
      <div>{policy.summary}</div>
    </header>
    <article className="policy-document">
      {policy.sections.map((section) => (
        <section key={section.heading}>
          <h2>{section.heading}</h2>
          {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {section.bullets && (
            <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>
          )}
        </section>
      ))}
      <Link className="policy-back" to="/policies">View all policies</Link>
    </article>
  </main>
);

export const RoutedPolicyPage = () => {
  const { slug } = useParams();
  const policy = policyMap[slug];
  return policy ? <PolicyDocument policy={policy} /> : <Navigate to="/policies" replace />;
};

export const PolicyCenter = () => (
  <main className="policy-page policy-center" id="main">
    <header className="policy-hero">
      <p>Clear information for every order</p>
      <h1>Policy Centre</h1>
      <div>These policies reflect the physical catalogue and the shopping features that are actually present.</div>
    </header>
    <div className="policy-grid">
      {policies.map((policy) => (
        <Link key={policy.slug} to={`/policies/${policy.slug}`}>
          <span>{policy.title}</span>
          <p>{policy.summary}</p>
        </Link>
      ))}
    </div>
  </main>
);
